// ui-kit/searchbox — kotak cari daftar. Dipakai menu yang barisnya bisa ratusan
// (CRM, Laporan Servis, Piutang, DP, Beban, Hutang Supplier) supaya tak perlu menggulir.
//
// Kenapa jadi helper: tiap pemakai butuh debounce + MENGEMBALIKAN fokus & posisi kursor setelah
// render ulang (render mengganti elemen input-nya). Disalin per-menu, detail itu gampang terlewat
// dan hasilnya kursor melompat saat mengetik.
import { esc } from '@domain/format';

/** HTML kotak cari. `id` harus unik dalam satu layar. */
export const searchBoxHTML = (id: string, value: string, placeholder: string, label = 'Cari di daftar'): string =>
  `<input id="${id}" type="search" value="${esc(value)}" placeholder="${esc(placeholder)}" aria-label="${esc(label)}"
    style="height:30px;font-size:12.5px;padding:0 9px;border:1px solid var(--line);border-radius:8px;min-width:190px">`;

/**
 * Sambungkan kotak cari: debounce 300ms → simpan nilai → render ulang → fokus & kursor dikembalikan.
 * `rerender` harus me-render ulang layar yang sama (elemen input lama ikut terganti).
 */
export function wireSearchBox(root: HTMLElement, id: string, set: (v: string) => void, rerender: () => Promise<void> | void): void {
  const el = root.querySelector<HTMLInputElement>('#' + id);
  if (!el) return;
  let t = 0;
  el.addEventListener('input', () => {
    window.clearTimeout(t);
    const pos = el.selectionStart;
    const lama = el; // elemen yang akan diganti oleh render ulang
    t = window.setTimeout(() => {
      // Debounce tak pernah dibatalkan saat pindah menu, sedangkan SEMUA menu berbagi wadah #content.
      // Tanpa penjaga ini: ketik di Piutang → klik Dashboard dalam <300ms → debounce menyala dan
      // me-render Piutang MENIMPA Dashboard; pengguna terlempar balik tanpa sebab yang terlihat.
      // Elemen lama sudah lepas dari DOM begitu layar berganti.
      if (!el.isConnected) return;
      set(el.value);
      void Promise.resolve(rerender());
      // Banyak `refresh` di modul bertipe void (fire-and-forget), jadi menunggu nilai kembaliannya
      // TIDAK menjamin render selesai. Tunggu sampai elemen input BENAR-BENAR diganti, baru pulihkan
      // fokus + kursor. Tanpa ini, mengetik huruf berikutnya harus klik kotaknya lagi.
      let sisa = 12; // ~600ms; render tabel besar pun sudah lewat
      const pulihkan = (): void => {
        const n = root.querySelector<HTMLInputElement>('#' + id);
        if (n && n !== lama) {
          // JANGAN rebut fokus dari elemen lain: user bisa membuka dialog & mulai mengetik di sana
          // dalam jendela 600ms ini (modal hidup di luar `root`, jadi selamat dari render ulang).
          // Tanpa cek ini, ketikannya nyasar ke kotak cari di belakang modal.
          const aktif = document.activeElement;
          if (aktif === null || aktif === document.body || aktif === lama) { n.focus(); n.setSelectionRange(pos, pos); }
          return; // sudah dirender ulang → berhenti apa pun hasilnya
        }
        if (--sisa > 0) window.setTimeout(pulihkan, 50);
      };
      window.setTimeout(pulihkan, 50);
    }, 300);
  });
}
